import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { DriverValueTooltipLegacy } from './DriverValueTooltipLegacy';
import type { DriverProps } from './types';
export const IntroOffer = t0 => {
  const $ = _c(27);
  const {
    creditCardOffer,
    isMonetizing: t1,
    segmentActionSection,
    isRewardsOrSubprimeRU: t2
  } = t0;
  const isMonetizing = t1 === undefined ? true : t1;
  const isRewardsOrSubprimeRU = t2 === undefined ? false : t2;
  const {
    details: t3
  } = creditCardOffer;
  const {
    signUpBonusDetails: t4,
    introOfferDetails: t5
  } = t3;
  const {
    signUpBonusDetailsAnnotation
  } = t4;
  const {
    offerString,
    tooltipString,
    type
  } = t5;
  const displayTooltip = type !== "no rewards";
  const displayType = signUpBonusDetailsAnnotation ? false : type !== "cash" && type !== "no rewards";
  const offerId = creditCardOffer.id;
  let t6;
  if ($[0] !== isRewardsOrSubprimeRU) {
    t6 = isRewardsOrSubprimeRU && {
      minHeight: 0,
      minWidth: 0,
      containerStyles: {
        position: "relative" as const,
        top: "2px"
      },
      triggerIconHeight: 16,
      triggerIconWidth: 16
    };
    $[0] = isRewardsOrSubprimeRU;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== t6 || $[3] !== tooltipString) {
    t7 = {
      text: tooltipString,
      ariaLabel: "Intro Offer Details",
      ...t6
    };
    $[2] = t6;
    $[3] = tooltipString;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const tooltipProps = t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    };
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = displayTooltip ? "26px" : 0;
  let t10;
  if ($[6] !== t9) {
    t10 = {
      paddingRight: 1,
      marginRight: t9,
      fontSize: "inherit"
    };
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== offerString || $[9] !== t10) {
    t11 = <Typography component="span" sx={t10}>{offerString}</Typography>;
    $[8] = offerString;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== displayTooltip || $[12] !== isMonetizing || $[13] !== offerId || $[14] !== segmentActionSection || $[15] !== tooltipProps) {
    t12 = displayTooltip && <Box sx={{
      display: "inline-block",
      marginLeft: "-26px"
    }}><DriverValueTooltipLegacy {...tooltipProps} driverKey="introoffer" segmentActionSection={segmentActionSection} isMonetizing={isMonetizing} offerId={offerId} /></Box>;
    $[11] = displayTooltip;
    $[12] = isMonetizing;
    $[13] = offerId;
    $[14] = segmentActionSection;
    $[15] = tooltipProps;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <Box>{t11}{t12}</Box>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== displayType || $[21] !== isRewardsOrSubprimeRU || $[22] !== type) {
    t14 = displayType && <Typography variant="bodySmall" sx={{
      textTransform: "capitalize",
      fontSize: isRewardsOrSubprimeRU ? "12px" : "13px"
    }}>{type}</Typography>;
    $[20] = displayType;
    $[21] = isRewardsOrSubprimeRU;
    $[22] = type;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = <Box sx={t8}>{t13}{t14}</Box>;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
};
export const IntroOfferTitle = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="textSmall" sx={{
      fontWeight: 700,
      fontSize: 16
    }}>Intro offer</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};